<dialog-header
  [title]="data?.title || 'Create Variant'"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    padding-bottom: 20px;
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
  "
>
  <form [formGroup]="form" style="margin-top: 20px">
    <div class="form-field">
      <div class="form-field-label">Name<span style="color: red">*</span></div>
      <input
        class="form-input"
        [formControl]="nameFormControl"
        maxlength="50"
        autocomplete="off"
      />
    </div>

    <div class="form-field" style="margin-top: 15px">
      <div class="form-field-label">
        Conditions<span style="color: red">*</span>
      </div>

      <div class="form-field" style="margin-top: 10px">
        <single-select
          label="Condition Type"
          [formCtrl]="conditionTypeFormControl"
          [options]="conditionTypeOptions"
          property="label"
          [value]="conditionTypeFormControl.value"
        ></single-select>
      </div>

      <div
        style="display: flex; gap: 8px; align-items: center; margin-top: 10px"
        *ngIf="conditionTypeFormControl.value?.value"
      >
        <input
          class="form-input"
          style="margin-bottom: 0"
          [formControl]="conditionValueFormControl"
          placeholder="Enter condition value"
          autocomplete="off"
          (keyup.enter)="addCondition()"
        />
        <app-primary-button
          [title]="editingConditionIndex >= 0 ? 'Update' : 'Add'"
          [disabled]="!canAddCondition"
          (tapped)="addCondition()"
          bgColor="var(--app-timber)"
          color="white"
        ></app-primary-button>
      </div>

      <div class="conditions-list" *ngIf="conditions.length">
        <div
          class="condition-item"
          *ngFor="let condition of conditions; let i = index"
        >
          <span
            ><b>{{ getConditionTypeLabel(condition.type) }}:</b>
            {{ condition.value }}</span
          >
          <div style="display: flex; gap: 6px">
            <button mat-icon-button type="button" (click)="editCondition(i)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button type="button" (click)="removeCondition(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="form-field" style="margin-top: 15px">
      <div class="form-field-label">Priority</div>
      <input
        class="form-input"
        type="number"
        [formControl]="priorityFormControl"
      />
    </div>

    <div
      class="form-field"
      style="
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      "
    >
      <div class="form-field-label" style="margin-bottom: 0">Active</div>
      <mat-slide-toggle [formControl]="activeFormControl"></mat-slide-toggle>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <div style="margin-right: auto">
    <app-secondary-button
      *ngIf="data?.showDelete"
      title="Delete Variant"
      [disabled]="false"
      (tapped)="deleteVariant()"
      style="color: #d32f2f"
    ></app-secondary-button>
  </div>

  <app-secondary-button
    style="margin-right: 10px"
    title="Cancel"
    [disabled]="false"
    (tapped)="matDialogRef.close()"
  ></app-secondary-button>

  <app-primary-button
    [title]="data?.actionTitle || 'Create'"
    [disabled]="false"
    (tapped)="save()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>
